import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { explorerCategories, services } from '../data/serviceCatalog';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

// Services Explorer — 6 category tabs with dynamic service cards (matches user's reference)
export const ServicesExplorer = () => {
  const [active, setActive] = useState(explorerCategories[0].id);
  const cat = explorerCategories.find((c) => c.id === active);
  const list = (cat?.slugs || []).map((s) => services[s]).filter(Boolean);

  return (
    <section className="py-20 bg-[#FFF7EC]" data-testid="services-explorer-section">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl">
          <span className="inline-flex items-center gap-2 bg-emerald-50 border border-emerald-200 text-emerald-700 px-3.5 py-1 rounded-full text-xs font-semibold mb-3">
            <CheckCircle2 size={13} /> Registrations & Certifications
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-[#0A2463]">
            24+ business services, organized for you
          </h2>
          <p className="text-gray-600 mt-2 text-sm md:text-base">
            Pick the group that matches what you're trying to do — we handle the paperwork, the portal, and the follow-ups.
          </p>
        </div>

        {/* Category tabs */}
        <div className="mt-6 flex flex-wrap gap-2">
          {explorerCategories.map((c) => {
            const on = c.id === active;
            return (
              <button
                key={c.id}
                data-testid={`explorer-tab-${c.id}`}
                onClick={() => setActive(c.id)}
                className={`px-4 py-2 rounded-full text-sm font-semibold border transition-all ${
                  on
                    ? 'bg-[#0A2463] text-white border-[#0A2463] shadow-md'
                    : 'bg-white text-[#0A2463] border-gray-200 hover:border-[#0A2463]/40'
                }`}
              >
                {c.label} <span className={`ml-1.5 text-[11px] font-bold ${on ? 'text-[#FFB703]' : 'text-gray-500'}`}>{c.slugs.length}</span>
              </button>
            );
          })}
        </div>

        {cat?.desc && <p className="text-sm text-gray-500 mt-4">{cat.desc}</p>}

        {/* Service cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-5">
          {list.map((s) => {
            const I = s.icon;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                data-testid={`explorer-service-${s.slug}`}
                className="group bg-white rounded-2xl border border-[#F0DFC1] hover:border-[#FB8500] hover:shadow-lg transition-all p-4 flex items-start gap-3"
              >
                <div className="w-11 h-11 rounded-xl bg-orange-100 flex items-center justify-center flex-shrink-0 group-hover:scale-105 transition-transform">
                  <I className="text-[#FB8500]" size={20} />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-bold text-[#0A2463] leading-tight">{s.title}</h3>
                  <p className="text-xs text-gray-500 mt-0.5 line-clamp-1">{s.short}</p>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#FB8500] mt-2 group-hover:gap-2 transition-all">
                    Explore service <ArrowRight size={12} />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>

        {/* Bottom CTA banner */}
        <div className="mt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 bg-[#FFF3D6] border border-[#F5D77C] rounded-2xl p-4">
          <div className="text-sm text-gray-800">
            <span className="font-bold text-emerald-700">Not listed here?</span> Tell us what you need — most registrations follow the same process.
          </div>
          <Link to="/contact" data-testid="explorer-ask-advisor" className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-5 py-2.5 rounded-full text-sm shadow">
            Ask an Advisor <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesExplorer;
